module.exports = __webpack_public_path__ + "public/images/stands-left-bg.e4d017f3a026018e64a463d40b89032b.svg";